import { Component, OnInit } from "@angular/core";

import { UsersService } from "../services/users/users.service";

@Component({
  selector: "app-my-prescriptions",
  templateUrl: "./my-prescriptions.component.html",
  styleUrls: ["./my-prescriptions.component.scss"],
})
export class MyPrescriptionsComponent implements OnInit {
  results: any[] = [];
  selectedResult: any = null;
  showHistory = true;
  loading = false;
  message: string | null = null;

  activeTab: "EXTERNAL" | "INTERNAL" = "EXTERNAL";

  upload = {
    documentTypeCode: "",
    file: null as File | null,
  };

  uploading = false;
  uploadSuccessMessage = "";
  uploadErrorMessage = "";

  documentTypes: any[] = [];
  loadingDocumentTypes = false;

  constructor(private usersService: UsersService) {}

  ngOnInit(): void {
    this.loadItems();
    this.loadDocumentTypes();
  }

  loadItems(): void {
    this.loading = true;
    this.message = "Se încarcă documentele...";

    this.usersService.getMyDocuments().subscribe({
      next: (data: any[]) => {
        this.results = (data || []).sort(
          (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
        );
        this.loading = false;
        this.message = this.results.length
          ? null
          : "Nu ai documente sau prescripții înregistrate.";
      },
      error: () => {
        this.loading = false;
        this.results = [];
        this.message = "A apărut o eroare la încărcarea documentelor.";
      },
    });
  }

  loadDocumentTypes(): void {
    this.loadingDocumentTypes = true;

    this.usersService.getDocumentTypes().subscribe({
      next: (data: any[]) => {
        this.documentTypes = data || [];
        this.loadingDocumentTypes = false;
      },
      error: () => {
        this.loadingDocumentTypes = false;
        this.documentTypes = [];
        console.error("Eroare la încărcarea tipurilor de documente");
      },
    });
  }

  loadDetails(result: any): void {
    this.selectedResult = result;
    this.showHistory = false;
  }

  backToHistory(): void {
    this.showHistory = true;
    this.selectedResult = null;
  }

  download(document: any) {
    this.usersService.download(document);
  }

  share(result: any): void {
    console.log("Share result uuid:", result.uuid);
  }

  setActiveTab(tab: "EXTERNAL" | "INTERNAL"): void {
    this.activeTab = tab;
  }

  get filteredResults(): any[] {
    return this.results.filter((result) => result.source === this.activeTab);
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      this.upload.file = null;
      return;
    }

    this.upload.file = input.files[0];
    this.uploadSuccessMessage = "";
    this.uploadErrorMessage = "";
  }

  clearSelectedFile(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }

    this.upload.file = null;
    this.uploadSuccessMessage = "";
    this.uploadErrorMessage = "";
  }

  uploadDocument(): void {
    if (!this.upload.documentTypeCode || !this.upload.file) {
      return;
    }

    this.uploading = true;
    this.uploadSuccessMessage = "";
    this.uploadErrorMessage = "";

    const file = this.upload.file;
    const fileName = file.name;

    this.usersService
      .uploadDocument(this.upload.documentTypeCode, fileName, file)
      .subscribe({
        next: () => {
          this.uploading = false;
          this.uploadSuccessMessage =
            "Documentul a fost încărcat cu succes.";
          this.clearSelectedFile();
          this.loadItems();
        },
        error: () => {
          this.uploading = false;
          this.uploadErrorMessage =
            "A apărut o eroare la încărcarea documentului. Încercați din nou.";
        },
      });
  }
}